export default __webpack_public_path__ + "maps-guides-markers-annotations-view-1200-898abf7ce4aa4b6f2475d899ac347e64.png";